import { useEffect, useState } from "react";
import {
  supabaseAuthenticatedApi,
  workspaceAgentUrl,
} from "../components/SupabaseClient";

export function useRemoteFileMetadata(source, filePath) {
  const [metadata, setMetadata] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!source || !filePath) {
      setMetadata(null);
      setLoading(false);
      setError(null);
      return;
    }

    let active = true;

    const loadMetadata = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await supabaseAuthenticatedApi.post(
          "/filesystem/stat-file",
          { scope: source, path: filePath },
          workspaceAgentUrl,
          10000,
        );
        const data = await response.json();
        if (!active) return;

        setMetadata({
          fileName: data.file_name || filePath.split("/").pop() || filePath,
          filePath: data.path || filePath,
          size: data.size_bytes ?? null,
          mode: data.mode || "",
          uid: data.uid ?? null,
          gid: data.gid ?? null,
          mtime: data.mtime ?? null,
          previewAllowed: data.preview?.allowed === true,
          allowForceOpen: data.preview?.allow_force_open === true,
          previewDenialReason: data.preview?.reason || null,
        });
      } catch (err) {
        if (!active) return;
        console.error("[useRemoteFileMetadata] Failed to fetch metadata:", err);
        setMetadata(null);
        setError(err.message || "Failed to load file metadata.");
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    loadMetadata();

    return () => {
      active = false;
    };
  }, [filePath, source]);

  return { metadata, loading, error };
}
